import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let internal = useDataValue({
    viewPath: props.viewPath,
    context: 'replace',
    path: 'selected_patient',
  })

  let submit = useDataSubmit({
    context: 'card',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'REPLACE_MATCH',
      internal,
    })
  }
}
